// 全局修复 ResizeObserver loop 报错
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // 防抖处理，避免循环触发
      requestAnimationFrame(() => {
        if (callback) callback(entries, observer)
      })
    })
  }
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/index.css' // 全局样式

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
